<template>

	<v-row>
		<v-col>

			<v-form v-model="formIsValid.campaignStatus" ref="campaignStatusForm" class="mb-8">
				<ui-box eager :form="$refs.campaignStatusForm">
					<v-row>
						<v-col>
							<h5>
								Campaign Status:
								<v-badge
										class="ms-1"
										:color="localCampaigns[0].active ? 'info' : 'warning'"
										:content="localCampaigns[0].active ? 'Active' : 'Inactive'"
								></v-badge>
							</h5>
						</v-col>
						<v-col>
							<h6>
								End Campaign: {{ endCampaignDate }}
							</h6>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<v-form v-model="formIsValid.sequenceActivation" ref="sequenceActivationForm"
							class="mb-8">
				<ui-box eager :form="$refs.sequenceActivationForm">
					<v-row>
						<v-col>
							<h5>Sequence Activation</h5>
							<span class="grey--text text--darken-1 text-body-2">
								Set a start date to begin email sequences. If email sequences should stop on a certain date, set an End Date.
								Otherwise all places will receive the full drip email sequence.
							</span>
						</v-col>
					</v-row>

					<v-divider class="mb-10 mt-4 opacity-80"></v-divider>
					<v-row>
						<v-col cols="12" sm="6">
							<bw-date-time-picker
									v-model="localCampaigns[0].email_settings.dripSequences[0].activationDate"
									class="rounded-lg required"
									label="Start Date"
									:required="true"
									:with-time="true"
									:rules="rules.start_date"
							></bw-date-time-picker>
						</v-col>
						<v-col cols="12" sm="6">
							<bw-date-time-picker
									class="rounded-lg"
									v-model="localCampaigns[0].email_settings.dripSequences[0].endDate"
									label="End Date"
									:with-time="true"
							></bw-date-time-picker>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<v-form v-model="formIsValid.viewCampaignEmails" ref="viewCampaignEmailsForm"
							class="mb-8">
				<ui-box eager :form="$refs.viewCampaignEmailsForm">
					<v-row>
						<v-col>
							<h5>View Campaign Emails</h5>
							<span class="grey--text text--darken-1 text-body-2">
								View the emails that will be sent to the Places invited to join the pass
							</span>
						</v-col>
					</v-row>
					<v-divider class="mb-10 mt-4 opacity-80"></v-divider>
					<v-row v-if="dripSequencesLoading">
						<v-col>
							<v-progress-circular
									color="primary"
									indeterminate
									width="2"
							></v-progress-circular>
						</v-col>
					</v-row>
					<v-row v-if="!dripSequencesLoading && localDripSequences.length > 0">
						<v-col>
							<template v-for="(dripSequence, sequenceIdx) in localDripSequences">
								<v-row :key="`sequence-${sequenceIdx}`">
									<v-col>
										<v-row>
											<v-col>
												<h6 class="mb-4">{{ dripSequence.name }}</h6>
											</v-col>
										</v-row>
										<template v-for="(drip, dripIdx) in dripSequence.drips">
											<v-row :key="`drip-${dripIdx}`">
												<v-col>
													Email {{ drip.message.index }}: {{ drip.message.subject }}
												</v-col>
												<v-col cols="auto">
													<v-btn
															color="accent"
															outlined
															depressed
															fab
															small
															@click="showMessagePreview(drip.message)"
													>
														<v-icon>
															mdi-clipboard-text-search
														</v-icon>
													</v-btn>

												</v-col>
											</v-row>
										</template>
									</v-col>
								</v-row>
							</template>
						</v-col>
					</v-row>
					<v-row v-if="!dripSequencesLoading && localDripSequences.length === 0">
						<v-col>
							<h6>No Sequences</h6>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<save-form
					:refs="$refs"
					:is-saving="isSaving"
					save-text="Save"
					@cancel-action="exit"
					@save-action="save"
			></save-form>

			<v-dialog
					v-model="dialog.message"
					content-class="rounded-xl"
					persistent
					scrollable
					width="1000px"
			>
				<v-form v-model="formIsValid.message" ref="formMessage">
					<v-card class="position-relative" rounded="xl">
						<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
							<div class="w-100">
								<div class="align-center d-flex justify-space-between">
									<h6>Email Preview</h6>
									<v-btn
											class="mt-n1 me-n2"
											color="black"
											depressed
											icon
											@click="hideMessagePreview"
									>
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</div>
							</div>
						</v-card-title>
						<v-card-text class="text-body-2">
							<v-row>
								<v-col>
									<v-text-field
											v-model="previewMessage.subject"
											class="rounded-lg"
											hide-details="auto"
											label="Subject"
											outlined
											readonly
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-textarea
											v-model="previewMessage.message"
											class="rounded-lg"
											hide-details="auto"
											label="Message"
											outlined
											rows="12"
											type="text"
											readonly
									></v-textarea>
								</v-col>
							</v-row>
						</v-card-text>

						<v-card-actions>
							<div class="align-center d-flex justify-space-between w-100">
								<span></span>
								<div class="d-flex justify-end">
									<v-btn
											class="me-2 me-md-4 rounded-lg"
											color="grey darken-1"
											depressed
											:large="$vuetify.breakpoint.mdAndUp"
											outlined
											@click="hideMessagePreview"
									>
										Close
									</v-btn>
								</div>
							</div>
						</v-card-actions>
					</v-card>
				</v-form>
			</v-dialog>

		</v-col>
	</v-row>

</template>

<script>

import { Place } from '../../../helpers';
import * as _ from 'lodash';

export default {
	name: "Sequences",
	props: {
		partner: {
			type: Object,
			default: () => ({})
		},
		pass: {
			type: Object,
			default: () => ({})
		},
		places: {
			type: Array,
			default: () => []
		},
		user: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			dialog: {
				message: false,
			},
			dripSequencesLoading: true,
			formIsValid: {
				campaignStatus: false,
				sequenceActivation: false,
				viewCampaignEmails: false,
				message: false
			},
			previewMessage: {
				subject: null,
				message: null
			},
			isSaving: false,
			localCampaigns: [...this.pass.campaigns],
			localPass: this.pass,
			localPlaces: [],
			localDripSequences: [],
			rules: {
				start_date: [v => !!v || 'Start date is required.']
			}
		};
	},
	async mounted() {
		this.places.forEach(place => this.localPlaces.push(new Place(place)));
		this.localDripSequences = await this.getDripSequences();
	},
	computed: {
		endCampaignDate() {
			if(this.localCampaigns[0]?.inactivation_date && this.localCampaigns[0].inactivation_date !== '0000-00-00 00:00:00') {
				return moment(this.localCampaigns[0].inactivation_date).format('YYYY-MM-DD')
			}
			else if(this.localCampaigns[0]?.end_date && this.localCampaigns[0].end_date !== '0000-00-00 00:00:00') {
				return moment(this.localCampaigns[0].end_date).format('YYYY-MM-DD');
			}
			else {
				return 'N/A';
			}
		},
	},
	methods: {
		exit() {
			window.location.href = `/partner-portal/${this.partner.id}/passes`;
		},

		async getDripSequences() {
			let dripSequences = this.localCampaigns[0]?.email_settings?.dripSequences?.length > 0
					? _.cloneDeep(this.localCampaigns[0].email_settings.dripSequences)
					: [];
			if(dripSequences.length > 0) {
				//Remove the first item of the first drip sequence, because it is shown on Invites
				dripSequences[0].drips.shift();
				//Remove the third drip sequence if present
				if(dripSequences.length > 2) {
					dripSequences.pop();
				}

				//Replace the variables on all messages
				try {
					const url = `/partner-portal/${this.partner.id}/passes/get-drip-sequences-message-contents`;
					const response = await axios.post(url, {
						dripSequences: dripSequences,
						dealId: this.pass.id,
						campaignId: this.localCampaigns[0]?.id,
						venueId: this.localPlaces[0]?.id,
						launchDate: this.pass.launch_date,
						endDate: this.localCampaigns[0]?.end_date,
					});
					dripSequences = response.data.dripSequences;

					//add the 'Email n:' legend to each subject
					let emailIdx = 2; //Start at the second drip in the first sequence
					dripSequences.forEach(dripSequence => {
						dripSequence.drips.forEach(drip => {
							if(drip.message?.subject) {
								this.$set(drip.message, 'index', emailIdx++);
							}
						});
						emailIdx = 1;
					});
				}
				catch (error) {
					window.EventBus.$emit('system-messages', [
						{ message: error.message, messageType: 'error' }
					]);
				}
			}
			this.dripSequencesLoading = false;
			return dripSequences;
		},

		showMessagePreview(message) {
			this.dialog.message = true;
			this.previewMessage.subject = message.subject;
			this.previewMessage.message = message.message;
		},

		hideMessagePreview() {
			this.dialog.message = false;
			this.previewMessage.subject = null;
			this.previewMessage.message = null;
		},

		save() {
			this.isSaving = true;
			const url = `/partner-portal/${this.partner.id}/passes/save-campaigns/${this.localPass.id || ''}`;

			axios.put(url, { pass: this.pass, campaigns: this.localCampaigns })
					.then(({ data }) => {
						window.location = `/partner-portal/${this.partner.id}/passes/${this.localPass.id}/submissions`;
					})
					.catch(error => {
						this.isSaving = false;
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					});
		},
	}
}

</script>
